import { useEffect, useState } from 'react';

import { RatePlanFilter } from 'ProviderRatePlan-Types';

export type PriceRangeType = number | null | undefined;

type FilterPriceOptions = {
  min?: number;
  max?: number;
};

type Features = {
  features: Array<string>;
  maxPrice: PriceRangeType;
  minPrice: PriceRangeType;
  freeCancellation: boolean;
};

function useFilterCount(features: Features, filterOptions: Array<RatePlanFilter>) {
  const [featuresCount, setFeaturesCount] = useState(0);
  const [filterPriceOptions, setFilterPriceOptions] = useState<FilterPriceOptions>({});

  useEffect(() => {
    const filterOptionsPrize = filterOptions.find(el => el.min || el.max);

    setFilterPriceOptions({
      min: filterOptionsPrize?.min,
      max: filterOptionsPrize?.max,
    });
  }, [filterOptions]);

  useEffect(() => {
    let filter = features.features.filter(el => el).length;
    // TODO: count star rating as one.
    if (features.maxPrice || features.minPrice) {
      filter += 1;
    }
    if (features.freeCancellation) {
      filter += 1;
    }
    setFeaturesCount(filter);
  }, [features, filterPriceOptions.max, filterPriceOptions.min]);

  return featuresCount;
}

export default useFilterCount;
